import { Button, Image, Spin, Switch, Table, Tabs } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import SlideApi from '../../../functions/api/user/SlideApi';

function HomeSlideList(props) {
  let history = useHistory();

  const [listSlide, setListSlide] = useState([]);

  useEffect(() => {
    SlideApi.getAllSlide().then(setListSlide);
  }, []);

  const formatActive = (cell, row) => {
    return (
      <Switch
        onChange={(checked) => handleUpdate(row.id, checked)}
        defaultChecked={row.is_active}
      />
    );
  };

  const formatImage = (link) => {
    return <Image width={200} height={100} src={link} />;
  };

  async function handleUpdate(id, isActive) {
    const status = isActive;
    await SlideApi.updateSlide(id, status);
  }

  const columnSlides = [
    {
      title: 'Slide id',
      dataIndex: 'id',
      key: 'id',
      fixed: 'left',
    },
    {
      title: 'Ảnh/Link ảnh',
      dataIndex: 'slide_url',
      key: 'slide_url',
      fixed: 'left',
      render: formatImage,
    },
    {
      title: 'Mô tả',
      dataIndex: 'description',
      key: 'description',
      fixed: 'left',
    },
    {
      title: 'Hiển thị trên website',
      dataIndex: 'is_active',
      key: 'is_active',
      width: 300,
      render: formatActive,
    },
  ];

  if (!listSlide.length > 0) {
    return <Spin />;
  }

  return (
    <>
      <h1>Quản lí slide</h1>
      <Button
        onClick={() => history.push('/slide/add')}
        type="primary"
        size="large"
      >
        Thêm
      </Button>
      <Tabs defaultActiveKey="1" centered>
        <Tabs.TabPane tab="Slide" key="1">
          <Table
            rowKey="id"
            size="small"
            columns={columnSlides}
            dataSource={listSlide}
            scroll={{ x: 'max-content' }}
          />
        </Tabs.TabPane>
      </Tabs>
    </>
  );
}

export default withRouter(HomeSlideList);
